import port1 from '../img/portImages/maya-1.jpg';
import port2 from '../img/portImages/port1.png';
import port3 from '../img/portImages/T-Martbd.png';
import port4 from '../img/portImages/cooking-master.png';
import port6 from '../img/portImages/penguine.png';
import port7 from '../img/portImages/interview.png';
import port8 from '../img/portImages/student-read.png';
import port9 from '../img/portImages/retro-blog.png';

const portfolios = [
    {
        id: 1,
        category: 'Companion',
        link1: 'https://companion-e998b.web.app/',
        link2: 'https://github.com/Mainul-Fahim/companion-client',
        link3: 'https://github.com/Mainul-Fahim/companion-server',
        icon1: 'Website',
        icon2: 'Client',
        icon3:'Server',
        technology:'React Bootstrap Node MongoDB Firebase Heroku ',
        image: port1,
        title: 'Companion'
    },
    {
        id: 2,
        category: 'Python',
        link1: 'https://house-of-books-a3b39.web.app/',
        link2: 'https://github.com/Mainul-Fahim/house-of-ebooks',
        link3: 'https://github.com/Mainul-Fahim/house-of-ebooks-server',
        icon1: 'Website',
        icon2: 'Client',
        icon3:'Server',
        technology:'React Bootstrap Node MongoDB Firebase Heroku ',
        image: port2,
        title: 'House of E-books'
    },
    {
        id: 3,
        category: 'T-MartBd',
        link1: 'https://www.tmartbd.com/',
        link2: '',
        icon1: 'Website',
        icon2: 'Client',
        technology:'React Django Aws ',
        image: port3,
        title: 'T-MartBd'
    },
    {
        id: 4,
        category: 'Interview Kit',
        link1: 'https://interview-kit-2d5c1.web.app/',
        link2: 'https://github.com/Mainul-Fahim/interview_kit',
        icon1: 'Website',
        icon2: 'Client',
        technology:'React Redux Bootstrap Firebase Enzyme & Zest',
        image: port7,
        title: 'Interview Kit'
    },
    {
        id: 5,
        category: 'Javascript',
        link1: 'https://student-read.web.app/',
        link2: 'https://github.com/Mainul-Fahim/student_client',
        link3: 'https://github.com/Mainul-Fahim/student_server',
        icon1: 'Website',
        icon2: 'Client',
        technology:'React Bootstrap Node MongoDB Firebase Heroku',
        image: port8,
        title: 'Student Hub'
    },
    {
        id: 6,
        category: 'Javascript',
        link1: 'https://read-d59b4.web.app/',
        link2: 'https://github.com/Mainul-Fahim/retro_blog_client',
        link3: 'https://github.com/Mainul-Fahim/retro_blog_server',
        icon1: 'Website',
        icon2: 'Client',
        technology:'React Bootstrap Node MongoDB Firebase Heroku',
        image: port9,
        title: 'Retro Blog'
    },
    {
        id: 7,
        category: 'Javascript',
        link1: 'https://mainul-fahim.github.io/cooking-master/',
        link2: 'https://github.com/Mainul-Fahim/cooking-master',
        icon1: 'Website',
        icon2: 'Client',
        technology:'HTML CSS Bootstrap Javascript ',
        image: port4,
        title: 'Cooking Master'
    },
    {
        id: 8,
        category: 'React Js',
        link1: 'https://mainul-fahim.github.io/penguine-fashion/',
        link2: 'https://github.com/Mainul-Fahim/penguine-fashion',
        icon1: 'Website',
        icon2: 'Client',
        technology:'HTML CSS Bootstrap Javascript ',
        image: port6,
        title: 'Penguine Fashion'
    }
    
]

export default portfolios;